import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getUserList } from "_services/userService";
import useDocumentTitle from "hooks/useDocumentTitle";
import { EditUserProfile } from "modals";
import { getSifarishPoints, removeLoginSession } from "_services";
import { Images } from "constants";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SifarishPoints = () => {
  useDocumentTitle("User | MySifarish");
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [userListData, setUserListData] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;
  const [isOpen, setIsOpen] = useState(false);
  const [isSuccessMsg, setIsSuccessMsg] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exportLoad, setExportLoad] = useState(false);
  const [persistedState, setPersistedState] = useState(location);

  // const [selectedRange, setSelectedRange] = useState({
  //   // startDate: moment().startOf("month"),
  //   // endDate: moment().endOf("month"),
  //   startDate: "",
  //   endDate: "",
  // });

  // const [filter, setFilter] = useState({
  //   userId: "",
  //   page: 1,
  //   limit: 20,
  //   startDate: null,
  //   endDate: null,
  //   isActive: "",
  //   type: "",
  //   userIdToFetch: "",
  // });

  const initialFilter = {
    userId: "",
    page: 1,
    limit: 20,
    startDate: "",
    endDate: "",
    keyword: "",
    type: "",
    isActive: "",
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [filter, setFilter] = useState({
    ...initialFilter,
    userId: searchParams.get("userId") || "",
    page: Number(searchParams.get("page")) || 1,
    limit: Number(searchParams.get("limit")) || 20,
    type: searchParams.get("type") || "",
    isActive: searchParams.get("isActive") || "",
    startDate: searchParams.get("startDate")
      ? moment(searchParams.get("startDate"))
      : "",
    endDate: searchParams.get("endDate")
      ? moment(searchParams.get("endDate"))
      : "",
    keyword: searchParams.get("keyword") || "",
  });

  const [selectedRange, setSelectedRange] = useState({
    startDate: filter.startDate,
    endDate: filter.endDate,
  });

  useEffect(() => {
    const params = {};

    Object.entries(filter).forEach(([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        !(moment.isMoment(value) && !value.isValid())
      ) {
        params[key] = moment.isMoment(value)
          ? value.format("YYYY-MM-DD")
          : value;
      }
    });

    setSearchParams(params);
  }, [filter, setSearchParams]);

  useEffect(() => {
    if (location?.state && !persistedState) {
      setPersistedState(location);
    }
  }, [location.state]);

  const handleReset = () => {
    setFilter(initialFilter);
    setSearchParams({});
    setSelectedRange({ startDate: null, endDate: null });
  };

  const hasActiveFilters = Object.keys(initialFilter).some((key) => {
    if (key === "page" || key === "limit") return false;

    const currentValue = filter[key];
    const initialValue = initialFilter[key];

    const normalize = (val) =>
      val === "" || val === null || val === undefined ? null : val;

    const curr = normalize(currentValue);
    const init = normalize(initialValue);

    if (moment.isMoment(curr)) {
      return (
        curr.isValid() && (!moment.isMoment(init) || !curr.isSame(init, "day"))
      );
    }

    return curr !== init;
  });

  //   useEffect(() => {
  //     if (getUserData?._id) {
  //       // fetchActiveSession();
  //       fetchlistUserData(getUserData._id);
  //     }
  //   }, [getUserData?._id]);

  useEffect(() => {
    const id = persistedState?.state?._id;

    if (id) {
      fetchSifarishPoints(id);
    } else {
      fetchSifarishPoints();
    }
  }, [filter, selectedRange]);

  const fetchlistUserData = async (data) => {
    try {
      const payload = {
        userId: data,
        limit: 200,
      };
      const res = await getUserList(payload);
      if (res) {
        setUserDataList(res?.data?.users);
      } else {
        toast.error(res?.responseMessage);
        setUserDataList([]);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setUserDataList([]);
    }
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];

    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination">
        <li className={`page-item ${filter.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter.page === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const fetchSifarishPoints = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        // startDate: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        // endDate: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
        // userId: data?.userId ? data?.userId : getUserData?._id,
        isActive: filter?.isActive,
        userIdToFetch: data
          ? data
          : filter?.userIdToFetch
          ? filter?.userIdToFetch
          : "",
        userId: getUserData._id,
      };
      const res = await getSifarishPoints(payload);
      if (res) {
        setUserListData(res?.data?.notifications);
        setTotalCount(res?.data?.totalRecords);
        setLoading(false);
      } else {
        toast.error(res?.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const submitDeleteUser = async () => {
    const payload = {
      userId: getUserData?._id,
      tokenToRemove: isDelete?.token,
    };
    try {
      const res = await removeLoginSession(payload);
      if (res) {
        // fetchActiveSession();
        setIsDelete(false);
        setIsSuccessMsg(res?.message);
        toast.success(res?.message);
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setIsDelete(false);
    }
  };

  const propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteUser,
  };

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const columns = [
    { header: "", accessor: "seriall" },
    { header: "User Name", accessor: "user_name" },
    { header: "Sifarish Points", accessor: "sifarishPoints" },
    { header: "Type", accessor: "type" },
    { header: "Created Date", accessor: "created_date" },
  ];

  const rowListData = (data) =>
    data?.map((item, i) => ({
      ...item,
      serial: (
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
          </div>
        </div>
      ),
      sifarishPoints: item?.sifarishPoints || "-",
      type: item?.type.replace(/_/g, " ") || "-",
      created_date: formatDateToDDMMYYYY(item?.createdAt) || "-",
      user_name: (
        <>
          <Link
            to={
              item?.userId?._id
                ? `/user/details/${item?.userId?._id}`
                : undefined
            }
            className="__userPro"
            onClick={(e) => {
              if (!item?.userId?._id) e.preventDefault();
            }}
          >
            <img
              src={item?.userId?.userProfileImageUrl || Images.USERLIMG}
              alt="user Img"
              style={{ borderRadius: "50%" }}
              width={30}
              height={30}
            />
            <span>
              {item?.userId
                ? `${item?.userId?.firstName} ${item?.userId?.lastName}`
                : "User Deleted"}
            </span>
          </Link>
        </>
      ),
    }));

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      page: 1,
      startDate: newRange.startDate,
      endDate: newRange.endDate,
    }));
  };

  const EditUserModal = {
    isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Edit User",
    footerPart: true,
    submitTitle: "Edit User",
    // onSuccess: () => fetchActiveSession(getUserData._id),
  };

  const handleRemoveTitle = () => {
    navigate(persistedState.pathname, { replace: true });
    fetchSifarishPoints();
    setPersistedState(null);
  };

  const exportToCSV = async () => {
    const loadingToast = toast.loading(
      "Please wait, Sifarish Points data is getting exported..."
    );
    setExportLoad(true);

    try {
      const payload = {
        ...filter,
        userId: getUserData?._id,
        userIdToFetch: persistedState?.state?._id || "",
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
        page: 1,
        limit: 5000,
      };

      const firstRes = await getSifarishPoints(payload);

      if (
        !firstRes ||
        !firstRes.data?.notifications ||
        firstRes.data.notifications.length === 0
      ) {
        toast.dismiss(loadingToast);
        toast.error("No data to export!");
        setExportLoad(false);
        return;
      }

      const totalPages = firstRes.data.totalPages || 1;
      const totalRecords =
        firstRes.data.totalRecords || firstRes.data.notifications.length;

      toast.dismiss(loadingToast);
      toast.success(
        `Exporting ${totalRecords} records in ${totalPages} chunks...`
      );

      let allData = [...firstRes.data.notifications];

      for (let page = 2; page <= totalPages; page++) {
        let success = false;
        let retries = 3;

        while (!success && retries > 0) {
          try {
            const res = await getSifarishPoints({ ...payload, page });
            if (res?.data?.notifications?.length) {
              allData = [...allData, ...res.data.notifications];
            }
            success = true;
          } catch (err) {
            console.warn(`Retrying page ${page}... (${3 - retries + 1})`);
            retries--;
            await new Promise((r) => setTimeout(r, 1000));
          }
        }
      }

      const chunkSize = 30000;
      const numFiles = Math.ceil(allData.length / chunkSize);

      for (let i = 0; i < numFiles; i++) {
        const chunk = allData.slice(i * chunkSize, (i + 1) * chunkSize);

        const filterSummary = [
          // { label: "All", value: "" },
          // { label: "CREATE SIFARISH", value: "CREATE_SIFARISH" },
          // { label: "SAVE SIFARISH", value: "SAVE_SIFARISH" },
          // { label: "FORWARD SIFARISH", value: "FORWARD_SIFARISH" },
          // { label: "HELPFUL SIFARISH", value: "HELPFUL_SIFARISH" },
          // { label: "ADMIN BONUS", value: "ADMIN_BONUS" },
          {
            Key: "Award Type",
            Value:
              filter?.type === "CREATE_SIFARISH"
                ? "CREATE SIFARISH"
                : filter?.type === "SAVE_SIFARISH"
                ? "SAVE SIFARISH"
                : filter?.type === "FORWARD_SIFARISH"
                ? "FORWARD SIFARISH"
                : filter?.type === "HELPFUL_SIFARISH"
                ? "HELPFUL SIFARISH"
                : filter?.type === "ADMIN_BONUS"
                ? "ADMIN BONUS"
                : "All",
          },
          {
            Key: "Date Range",
            Value: selectedRange?.startDate
              ? `${moment(selectedRange.startDate).format(
                  "DD-MM-YYYY"
                )} - ${moment(selectedRange.endDate).format("DD-MM-YYYY")}`
              : "All Time",
          },
        ];

        const formattedData = chunk.map((user, index) => ({
          "Serial No": i * chunkSize + index + 1,
          "User Name":
            user?.userId === null
              ? "User Deleted"
              : `${user?.userId?.firstName || "-"} ${
                  user?.userId?.lastName || "-"
                }`,
          "Sifarish Points": user?.sifarishPoints || "-",
          "Award Type": user?.type || "-",
          "Created Date": formatDateToDDMMYYYY(user?.createdAt) || "-",
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([], { skipHeader: true });

        const keyColumn = "B";
        const valueColumn = "D";

        ws[`${keyColumn}1`] = { t: "s", v: "Filter Type" };
        ws[`${valueColumn}1`] = { t: "s", v: "Filter Value" };

        filterSummary.forEach((item, index) => {
          const rowNum = index + 3;
          ws[`${keyColumn}${rowNum}`] = { t: "s", v: item.Key };
          ws[`${valueColumn}${rowNum}`] = { t: "s", v: item.Value };
        });

        XLSX.utils.sheet_add_json(ws, formattedData, {
          origin: "A9",
          skipHeader: false,
        });

        const dataOnly = formattedData.map((r) => r);
        XLSX.utils.sheet_add_json(ws, dataOnly, {
          origin: "A10",
          skipHeader: true,
        });

        ws["!cols"] = [
          { wch: 10 },
          { wch: 30 },
          { wch: 20 },
          { wch: 20 },
          { wch: 25 },
        ];

        XLSX.utils.book_append_sheet(wb, ws, `Sifarish_Points_${i + 1}`);

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        const epochTime = Date.now();

        saveAs(blob, `Sifarish_Points_Part_${i + 1}_${epochTime}.xlsx`);
      }

      toast.success("All Sifarish Points data exported successfully!");
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error?.message || "Something went wrong during export.");
    } finally {
      setExportLoad(false);
    }
  };

  return (
    <>
      {/* {userDataList?.length > 0 && (
          )} */}
      <ButtonHeading
        title={`Sifarish Points `}
        titleName={`${
          persistedState?.state?._id ? persistedState?.state?.firstName : ""
        } ${persistedState?.state?._id ? persistedState?.state?.lastName : ""}`}
        handleRemoveTitle={() => handleRemoveTitle()}
        showCross={persistedState?.state?._id ? true : false}
        showDateRange={true}
        Export={true}
        ExportSubmit={exportToCSV}
        exportLoad={exportLoad}
        selectedRange={selectedRange}
        filter={filter}
        setFilter={setFilter}
        handleApply={handleApply}
        userDataList={userDataList}
        isShow={{
          // selectedUser: true,
          isSifarishType: true,
        }}
        handleReset={() => handleReset()}
        showResetFilter={hasActiveFilters}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(userListData?.length > 0 ? userListData : [])}
          isLoading={loading}
          colSpan={8}
        />
        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isOpen && userToEdit && (
        <EditUserProfile
          userId={getUserData?._id}
          userIdToUpdate={userToEdit._id}
          userData={userToEdit}
          props={EditUserModal}
        />
      )}

      {isDelete?._id && (
        <CommonModal {...propsDelete}>
          <p className="p-3"> Are you sure to remove this session?</p>
        </CommonModal>
      )}
    </>
  );
};

export default SifarishPoints;
